'use strict';

import { appState } from './appState.js';
import { VarMgr } from './VarMgr.js';

export async function loadImportPin() {
    const logOutUrl = VarMgr.get('logOutUrl');
    const errorUrl = VarMgr.get('errorUrl');
    var done = false;

    const globalCryptConf = appState.getGlobalCryptConf();
    if (typeof globalCryptConf !== 'undefined') {
        if (globalCryptConf.import) {
            done = true;
            const GuestImport = await window.AppBridge.GuestImport();
            new GuestImport({
                logOutUrl: logOutUrl,
                data: globalCryptConf.import
            });
        }
    }

    if (!done) {
        document.dispatchEvent(new CustomEvent('urlTools_goSafe', { detail: { url: errorUrl, type: 'redirect' } }));
    }

}